var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNumberNine = function SvgIconNumberNine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.285 14.368a6.25 6.25 0 1 1 4.003-2.785l-5.959 9.932a1 1 0 0 1-1.715-1.03zM7.75 8.25a4.25 4.25 0 1 1 7.948 2.096l-.009.014-.098.165A4.25 4.25 0 0 1 7.75 8.25",
    clipRule: "evenodd"
  })));
};
export default SvgIconNumberNine;